export const tourText = {
  createCourseButton: {
    title: 'Start a course',
    description: 'Click to create a new course using AI.',
  },
  courseCardContainer: {
    title: 'Your Courses',
    description: 'View and manage all your courses.',
  },
  courseCardInfoRightBox: {
    title: 'Unpublished',
    description: 'These courses are still being edited.',
  },
};
